import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Employee Screening Mirage Scenario
 * - `MIRAGE_SCENARIO='employee-screening' yarn start:mirage`
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  visitorsClassicScenario(server);
  const globalFlow = server.create('flow', {
    enabled: true,
    name: 'Employee registration',
    type: 'Flows::EmployeeScreening',
    summaryPage: () =>
      server.create('summary-page', {
        kind: 'none',
        defaultMessage: '# Access denied!',
        message: '# Access denied!',
      }),
  });

  server.create('sign-in-field-page', { flow: globalFlow });
}
